import { useField } from "formik"
import { Chip, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

import { MenuTemplateChannel } from "../menuTemplatesTypes"

const CHANNEL_OPTIONS: ReadonlyArray<MenuTemplateChannel> = [
    MenuTemplateChannel.MOBILE_APP,
    MenuTemplateChannel.CANTEEN_DISPLAY,
    MenuTemplateChannel.DIGITAL_SIGNS,
    MenuTemplateChannel.PRINT,
]

const useStyles = makeStyles()((theme) => ({
    chip: {
        height: "1.5rem",
        borderRadius: "6.25rem",
        padding: "0 .25rem",
        "& .MuiChip-label": {
            padding: "0 .5rem",
            fontSize: ".875rem",
        },
    },
    selectedChip: {
        background: theme.palette.tailwind.amber[200],
        color: theme.palette.tailwind.slate[800],
        border: `1px solid ${theme.palette.tailwind.amber[200]}`,
        "&:hover": {
            background: theme.palette.tailwind.amber[300],
            borderColor: theme.palette.tailwind.amber[300],
        },
    },
    unselectedChip: {
        background: theme.palette.common.white,
        color: theme.palette.tailwind.slate[800],
        border: `1px solid ${theme.palette.tailwind.slate[300]}`,
        "&:hover": {
            background: theme.palette.tailwind.slate[100],
        },
    },
}))

export function TemplateChannelPicker() {
    const { classes, cx } = useStyles()
    const { l10n } = useAppLocalization()
    const [field, , helpers] = useField<MenuTemplateChannel[]>("channels")

    const toggleChannel = (channel: MenuTemplateChannel) =>
        helpers.setValue(
            field.value.includes(channel)
                ? field.value.filter((selected) => selected !== channel)
                : [...field.value, channel],
        )

    return (
        <Stack direction="row" spacing=".5rem" flexWrap="wrap">
            {CHANNEL_OPTIONS.map((channel) => {
                const isSelected = field.value.includes(channel)
                return (
                    <Chip
                        key={channel}
                        clickable
                        label={l10n.getStringForEnum("merchant-menu-templates-channel", channel, channel)}
                        onClick={() => toggleChannel(channel)}
                        className={cx(classes.chip, isSelected ? classes.selectedChip : classes.unselectedChip)}
                    />
                )
            })}
        </Stack>
    )
}
